export const getURLParam = (name, url) => {
  const search = url ? new URL(url).search : location.search;
  const value = search.match(new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'));
  return value ? decodeURIComponent(value[1]) : '';
};
